module.exports = __webpack_public_path__ + "static/img/corp.4ccc292d.jpg";